import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiQaroniEnv } from '@qaroni-core/conf/apis/api-qaroni.config';
import { OriginApiObject } from '../types/origin.response';

@Injectable({
  providedIn: 'root',
})
export class OriginHttpService {
  private http = inject(HttpClient);

  public origins$() {
    const url = `${ApiQaroniEnv.URLBase}/admin/origins`;

    return this.http.get<OriginApiObject>(url);
  }
}
